import { useState } from "react";
import { BsChevronDoubleDown, BsWhatsapp  } from "react-icons/bs";
import { Provider } from "./components/ui/provider";
import { Button } from "@chakra-ui/react"
import { ReactComponent as SiteImg } from './assets/site2.svg';
import { ReactComponent as OrganizationImg } from './assets/organization.svg';
import { ReactComponent as ContatoImg } from './assets/contato.svg';
import { ReactComponent as ProdutividadeImg } from './assets/produtividade.svg';
import { ReactComponent as LogoImg } from './assets/logo.svg';
import logoChaske from './assets/logo-chaske.png';
import { MdClose } from "react-icons/md";
import useMediaQuery from '@mui/material/useMediaQuery';
const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const WIDTH_1000 = useMediaQuery("(max-width:1000px)")

  return (
    <Provider>
      <header style={styles.header}>
        <LogoImg style={styles.logoImg} alt="9 Bits" />

        {
          !WIDTH_1000? (
            <nav>
              <ul style={styles.navCelular}>
                <li><a href="#inicio" style={styles.navLink}>Início</a></li>
                <li><a href="#beneficios" style={styles.navLink}>Benefícios</a></li>
                <li><a href="#chaske" style={styles.navLink}>Chaske</a></li>
                <li><a href="#sucesso" style={styles.navLink}>Histórias</a></li>
                <li><a href="#sobre" style={styles.navLink}>Sobre</a></li>
                <li><a href="https://wa.me/5555997313484"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>Contato</a>
                </li>
              </ul>
            </nav>
          ) : (
            <div style={styles.menuToggle} onClick={toggleMenu}>
              {
                menuOpen? (
                  <MdClose color="#fff" size={38} />
                ) : (
                <>
                  <span style={styles.bar}></span>
                  <span style={styles.bar}></span>
                  <span style={styles.bar}></span>
                </>
                )
              }
              
            </div>
          )
        }
      </header>

      <nav>
        <ul style={{ ...styles.navList, ...(menuOpen ? styles.showMenu : {}) }}>
          <li><a href="#inicio" style={styles.navLink}>Início</a></li>
          <li><a href="#beneficios" style={styles.navLink}>Benefícios</a></li>
          <li><a href="#sucesso" style={styles.navLink}>Histórias</a></li>
          <li><a href="#envia-lembretes" style={styles.navLink}>EnviaLembretes</a></li>
          <li><a href="#sobre" style={styles.navLink}>Sobre</a></li>
          <li><a href="https://wa.me/5555997313484"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>Contato</a>
          </li>
        </ul>
      </nav>

      <section id="inicio" style={WIDTH_1000? styles.hero1600: styles.hero}>
        <SiteImg style={WIDTH_1000? styles.elementLeft1000: styles.elementLeft} alt="9 Bits Software" />
        <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column'}}>
          <h1 style={WIDTH_1000? styles.heroTitleCelular: styles.heroTitle}>Sistemas Personalizados para sua Empresa</h1>
          <h2 style={WIDTH_1000? styles.heroSubtitleCelular:styles.heroSubtitle}>
            Automatize seus processos e alcance o próximo nível com a 9 Bits Software.
            Peça seu orçamento agora mesmo.
          </h2>
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: WIDTH_1000? "column-reverse": "row" }}>
            
            <a href="#beneficios" style={styles.navLink}>
              <Button size="xl" rounded="full" style={{ marginTop: 20, backgroundColor: "#000", color: "#fff" }} colorPalette={"gray"}>
                  <BsChevronDoubleDown color="#fff" size="1em" />
                  Benefícios
                
              </Button>
            </a>

            <a href="https://wa.me/5555997313484"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Fale conosco pelo WhatsApp" style={styles.navLink}>
              <Button size="xl" rounded="full" style={{ marginTop: 20 }} colorPalette={"green"} >
                  <BsWhatsapp color="#fff" size="1em" />
                  Pedir orçamento
                
              </Button>
            </a>
          </div>

        </div>
      </section>

      <section id="beneficios" style={WIDTH_1000? styles.benefits1000: styles.benefits}>
        <h1 style={styles.title}>Alguns Benefícios de Utilizar um Sistema</h1>
        <div style={WIDTH_1000? { display: 'flex', flexDirection: 'column' }: { display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <OrganizationImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Organização" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Organização</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Tenha controle sobre os dados valiosos da sua empresa: Estoque, clientes, recebimentos...
              </p>
            </div>

          </div>

          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <ContatoImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Contato" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Contato</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Vá ao encontro de seus clientes com um site, mensagens ou área do cliente.
              </p>
            </div>

          </div>

          <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: 400, marginTop: 40} }>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 200, maxHeight: 200, borderRadius: 300, backgroundColor: '#64728C' }}>
              <ProdutividadeImg loading="lazy" style={{ display: 'flex', alignSelf: 'center', flex: 0.7 }} alt="Produtividade" />

            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <h2 style={WIDTH_1000? styles.benefitTitleCelular: styles.benefitTitle}>Produtividade</h2>
              <p style={WIDTH_1000? styles.benefitSubtitleCelular:styles.benefitSubtitle}>
                Acelere tarefas repetitivas com a segurança que um sistema oferece e foque em atividades que realmente importam.
              </p>
            </div>

          </div>
        </div>
        
      </section>

      <section id="chaske" style={WIDTH_1000? styles.lembretes1600: styles.lembretes}>
        <div style={WIDTH_1000? styles.elementLeft1000: styles.elementLeft}>
        <img style={{padding: 0, margin: 'auto'}} alt="Chaske" loading="lazy" src={logoChaske} />
        </div>
        <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column', alignSelf: 'center'}}>
          <h2 style={{color: "#000", fontSize: '1.6em', textAlign: 'left'}}>
            Use o WhatsApp da sua empresa para enviar lembretes automáticos de consultas, pagamentos, etc.
          </h2>
          <ul>
            <li style={WIDTH_1000? styles.lembretesSubtitleCelular:styles.lembretesSubtitle}>Receba o pagamento diretamente na sua conta bancária.</li>
            <li style={WIDTH_1000? styles.lembretesSubtitleCelular:styles.lembretesSubtitle}>Menos tempo gasto dos funcionários.</li>
            <li style={WIDTH_1000? styles.lembretesSubtitleCelular:styles.lembretesSubtitle}>Menor atrito com os clientes.</li>
            <li style={WIDTH_1000? styles.lembretesSubtitleCelular:styles.lembretesSubtitle}>0% de esquecimento.</li>
            <li style={WIDTH_1000? styles.lembretesSubtitleCelular:styles.lembretesSubtitle}>Utilizamos ferramentas oficiais do WhatsApp para garantir a qualidade e segurança do envio, sempre alinhados à LGPD.</li>
          </ul>
          
        </div>
      </section>      

      <section id="sucesso" style={styles.section}>
        <h2 style={styles.sectionTitle}>Histórias de Sucesso</h2>
        <div style={styles.testimonial}>
          <p>"O Mateus é um programador lúcido e inteligente, que entende logo as necessidades de desenvolvimento e consegue entregar um software de qualidade."</p>
          <p>- Pablo Ramon Prediger Garay | Farol Software (Ijuí)</p>
          <p style={styles.stars}>★★★★★ Sistemas diversos</p>
        </div>
        <div style={styles.testimonial}>
          <p>"Equipe extremamente responsável."</p>
          <p>- Daniel Fabiano Feltes | Portal Net (São Martinho)</p>
          <p style={styles.stars}>★★★★★ Sistema de lembretes.</p>
        </div>
      </section>

      <section id="sobre" style={WIDTH_1000? styles.sobre1600: styles.sobre}>
        <LogoImg style={WIDTH_1000? styles.elementLeft1000: styles.elementLeft} alt="Somos a 9 Bits" loading="lazy" />
        <div style={{paddingTop: 40, display: 'flex', flexDirection: 'column'}}>
          <h2 style={WIDTH_1000? styles.sobreTitleCelular: styles.sobreTitle}>Quem somos</h2>
          <p style={WIDTH_1000? styles.sobreSubtitleCelular:styles.sobreSubtitle}>
            Somos uma empresa focada em construir soluções do tamanho que você precisa. Focados em Santo Augusto e região, melhoramos os processos de várias empresas,
            sempre com com muito foco e responsabilidade. 
          </p>
          <p style={WIDTH_1000? styles.sobreSubtitleCelular:styles.sobreSubtitle}>
            Atuamos em diversos setores, entre eles: Agendamentos de horários para salões de beleza, etc. Sites para imobiliárias, Controle de estoque, etc.
          </p>
        </div>
      </section>

      <footer id="contato" style={styles.footer}>
        <p>© 2025 9 Bits Software. Todos os direitos reservados.
          CNPJ: 59.619.350/0001-83
        </p>
      </footer>

      <a
        href="https://wa.me/5555997313484"
        style={styles.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco pelo WhatsApp"
      >
        <BsWhatsapp />
      </a>
    </Provider>
  );
};

const styles = {
  header: {
    zIndex: 999,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    background: "#272E3B",
    padding: "8px",
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoImg: {
    height: 60,
    width: 110,
  },
  logo: {
    fontSize: "1.5em",
    color: "#fff",
  },
  menuToggle: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    cursor: "pointer",
  },
  bar: {
    background: "#fff",
    height: "3px",
    width: "25px",
  },
  navList: {
    height: 200,
    justifyContent: 'space-evenly',
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    background: "#272E3B",
    position: "fixed",
    top: "70px",
    right: 0,
    padding: "10px",
    borderRadius: "0px",
    zIndex: 2,
  },
  navCelular: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  showMenu: {
    display: "flex",
  },
  navLink: {
    color: "#fff",
    textDecoration: "none",
    margin: "10px 0",
    fontWeight: "bold",
    padding: 20
  },
  hero: {
    height: '90vh',
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "#fff",
    padding: "100px 20px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  hero1600: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#fff",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'space-between',
  },
  heroTitle: {
    fontSize: "2.5em",
  },
  heroTitleCelular: {
    fontSize: "1.5em",
  },
  heroSubtitle: {
    fontSize: "1.2em",
    color: "#333",
    fontWeight: 'bold'
  },
  heroSubtitleCelular: {
    fontSize: "1em",
    color: "#777",
    fontWeight: 'bold'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: "60px 20px",
    width: "100%",
    backgroundColor: '#1F2634',
    color: "#fff",
  },
  sectionTitle: {
    textAlign: "center",
    fontSize: "2em",
    marginBottom: "30px",
  },
  testimonial: {
    width: '100%',
    maxWidth: '800px',
    background: "#1a1a1a",
    padding: "20px",
    borderRadius: "10px",
    marginBottom: "20px",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
  },
  stars: {
    color: "gold",
  },
  footer: {
    background: "#111",
    textAlign: "center",
    padding: "30px",
    color: "#ccc",
  },
  whatsapp: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#25d366",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    fontSize: "24px",
    textDecoration: "none",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    zIndex: 10,
  },
  elementLeft: {
    width: '50%',
    alignSelf: 'center'
  },
  elementLeft1000: {
    width: '50%',
    alignSelf: 'center'
  },
  title: {
    fontSize: '2em',
    textAlign: 'center',
    color: '#7D95C1',
  },
  benefits: {
    height: '90vh',
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#192233",
    padding: "100px 20px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  benefits1000: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#192233",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'center',
    alignItems: 'center'
  },
  benefitTitle: {
    paddingLeft: 20,
    fontSize: "1.5em",
    color: '#6A9DFA'
  },
  benefitTitleCelular: {
    paddingTop: 20,
    fontSize: "1.2em",
    color: '#6A9DFA'
  },
  benefitSubtitle: {
    textAlign: 'left',
    paddingLeft: 20,
    fontSize: "1.2em",
    color: "#fff",
  },
  benefitSubtitleCelular: {
    textAlign: 'left',
    fontSize: "1em",
    color: "#fff",
  },
  sobre: {
    height: '90vh',
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "#090909",
    padding: "100px 80px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#3D7FFA",
  },
  sobre1600: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "#090909",
    padding: "100px 20px",
    textAlign: "center",
    color: "#3D7FFA",
    justifyContent: 'space-between',
  },
  sobreTitle: {
    fontSize: "2.5em",
  },
  sobreTitleCelular: {
    fontSize: "1.5em",
  },
  sobreSubtitle: {
    display: 'flex',
    textIdent: '2em',
    fontSize: "1.2em",
    color: "#ccc",
    fontWeight: 'normal',
    padding: "0 40px",
    textAlign: 'left',
    alignSelf: 'center'
  },
  sobreSubtitleCelular: {
    textIdent: '2em',
    display: 'flex',
    alignSelf: 'center',
    fontSize: "1em",
    color: "#ccc",
    fontWeight: 'normal',
    paddingHorizontal: "0 20px",
    textAlign: 'left'
  },

  lembretes: {
    height: '90vh',
    display: "flex",
    flexDirection: 'row',
    backgroundColor: "rgb(245, 245, 245)",
    padding: "100px 80px",
    justifyContent: 'space-evenly',
    textAlign: "center",
    color: "#214795",
  },
  lembretes1600: {
    display: "flex",
    flexDirection: 'column',
    backgroundColor: "rgb(245, 245, 245)",
    padding: "100px 20px",
    textAlign: "center",
    color: "#214795",
    justifyContent: 'space-between',
  },
  lembretesTitle: {
    fontSize: "2.5em",
  },
  lembretesTitleCelular: {
    fontSize: "1.5em",
  },
  lembretesSubtitle: {
    textIdent: '2em',
    display: 'flex',
    alignSelf: 'center',
    fontSize: "1.3em",
    color: "#1f4795",
    fontWeight: 'normal',
    padding: "10px 20px",
    textAlign: 'left',
    marginTop: 20,
    borderRadius: 8,
  },
  lembretesSubtitleCelular: {
    textIdent: '2em',
    display: 'flex',
    alignSelf: 'center',
    fontSize: "1.1em",
    color: "#fff",
    fontWeight: 'normal',
    padding: "10px 20px",
    textAlign: 'left',
    backgroundColor: '#1f4795',
    marginTop: 20,
    borderRadius: 8,
  },
};

export default App;
